/**
 * All possible values for the environment name, also known as the build-type.
 * @module site/constants/environments
 */

module.exports = {
  /** The local-dev environment. */
  LOCALHOST: 'localhost',

  /** The VA.gov dev environment */
  VAGOVDEV: 'vagovdev',

  /** The VA.gov staging environment. */
  VAGOVSTAGING: 'vagovstaging',

  /** The VA.gov production environment. */
  VAGOVPROD: 'vagovprod',
};
